export const fixBodyElement = (trigger: boolean) => {
  if (trigger) document.body.style.setProperty('overflow', 'hidden');
  else document.body.style.setProperty('overflow', 'auto');
};
